<template>
  <b-card>
    <b-card-header>
      <b-card-title>ایجاد صورت جلسه</b-card-title>
    </b-card-header>
    <b-card-body>
      <validation-observer
          #default="handleSubmit"
          ref="refFormObserver"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <validation-provider
                  #default="{errors}"
                  name="عنوان صورت جلسه"
                  rules="required"
              >
                <b-form-group
                    label="عنوان صورت جلسه"
                >
                  <b-form-input
                      v-model="title"
                      placeholder="عنوان صورت جلسه را وارد کنید"
                      :state="errors.length >0 ? true:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="متن صورت جلسه"
              >
                <div>
                  <quill-editor
                      v-model="description"
                      :options="editorOption"
                  />
                </div>

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <validation-provider
                  #default="{errors}"
                  name="اعضای جلسه"
                  rules="required"
              >
                <b-overlay :show="!getReceivers">
                  <b-form-group>
                    <label for="">اعضای جلسه</label>
                    <v-select
                        v-model="members"
                        multiple
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="receiversList"
                        :reduce="member => member.id"
                        :close-on-select="false"
                        :state="errors.length > 0 ? true:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </b-overlay>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                  #default="{errors}"
                  name="تاریخ جلسه"
                  rules="required"
              >
                <b-form-group
                    label="تاریخ جلسه"
                    label-for="meeting-date"
                >
                  <date-picker
                      v-model="meetingDate"
                      type="datetime"
                      clearable
                      :state="errors.length > 0 ? true:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

          </b-row>
          <hr>
          <div class="my-2">
            <h5>مصوبات</h5>
            <b-row
                v-for="(approval, index) in approvals"
                :id="index"
                :key="index"
                ref="row"
            >

              <!-- Item Name -->
              <b-col md="3">
                <b-form-group
                    label="عنوان"
                    label-for="item-name"
                >
                  <b-form-input
                      v-model="approval.title"
                      id="item-name"
                      type="text"
                      placeholder="عنوان را وارد کنید"
                  />
                </b-form-group>
              </b-col>

              <!-- Item Title -->
              <b-col md="3">
                <b-form-group
                >
                  <label for="">مجری</label>
                  <v-select
                      v-model="approval.userId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="receiversList"
                      :reduce="user => user.id"
                  />
                </b-form-group>
              </b-col>

              <!-- Item help -->
              <b-col md="4">
                <b-form-group
                    label="مهلت انجام"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="approval.dueDate"
                      type="datetime"
                      clearable
                      :min="checkDate"
                  />

                </b-form-group>

              </b-col>

              <!-- Profession -->

              <!-- Remove Button -->
              <b-col
                  lg="2"
                  md="3"
                  class="mb-50"
              >
                <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                >
                  <feather-icon
                      icon="XIcon"
                      class="mr-25"
                  />
                  <span>حذف</span>
                </b-button>
              </b-col>
              <b-col cols="12">
              </b-col>
            </b-row>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeatAgain"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
              />
              <span>افزودن مصوبه جدید</span>
            </b-button>
          </div>
          <hr>
          <b-row>
            <b-col cols="12">
              <b-row
                  v-for="(item, index) in attachment.items"
                  :id="item.id"
                  :key="item.id"
              >
                <!-- Item Name -->
                <b-col md="4">
                  <b-form-group>
                    <label :for="`attachment_${item.id}`">
                      <feather-icon
                          icon="PaperclipIcon"
                      />
                      فایل
                    </label>
                    <b-form-file
                        v-model="item.file"
                        placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                        drop-placeholder="عکس را به اینحا بکشید"
                        no-drop
                    />
                  </b-form-group>
                </b-col>

                <!-- Remove Button -->
                <b-col
                    lg="2"
                    md="3"
                    class="mb-50"
                >
                  <b-button
                      variant="outline-danger"
                      class="mt-0 mt-md-2"
                      @click="removeAttachItem(index)"
                  >
                    <feather-icon
                        icon="XIcon"
                        class="mr-25"
                    />
                    <span>حذف فایل</span>
                  </b-button>
                </b-col>
                <b-col cols="12">
                </b-col>
              </b-row>
              <b-button
                  variant="info"
                  @click="repeatAttachAgain"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                />
                <span>افزودن فایل پیوست</span>
              </b-button>
            </b-col>
          </b-row>
          <hr>
          <div class="demo-inline-spacing float-right">
            <b-button
                variant="success"
                :disabled="onProgress"
                @click="createTicket('publish')"
            >
              <b-spinner
                  v-if="onProgress"
                  small
              />
              {{ onProgress ? 'درحال پردازش درخواست...' : 'ثبت نهایی ' }}
            </b-button>
            <b-button
                variant="primary"
                :disabled="onProgress"
                @click="createTicket('draft')"
            >
              <b-spinner
                  v-if="onProgress"
                  small
              />
              {{ onProgress ? 'درحال پردازش درخواست...' : 'پیش نویس ' }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BFormFile,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { PersianNowDate } from '@/libs/utils'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'AgendaCreate',
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    BFormFile,
    quillEditor,

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      title: '',
      getReceivers: false,
      receiversList: [],
      members: [],
      onProgress: false,
      description: '',
      meetingDate: null,
      editorOption: {
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
      },
      attachment: {
        items: [],
        nextItemId: 1,
      },
      approvals: [],
      nextApprovalId: 1,
    }
  },
  computed: {
    checkDate() {
      return PersianNowDate()
    },
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })

  },
  methods: {
    repeatAgain() {
      this.approvals.push({
        id: '',
        title: '',
        userId: '',
        dueDate: '',
      })
      this.nextApprovalId++
    },
    removeItem(index) {
      this.approvals.splice(index, 1)
    },
    repeatAttachAgain() {
      this.attachment.nextItemId++
      this.attachment.items.push({
        id: this.attachment.nextItemId,
        file: null,
      })
    },
    removeAttachItem(index) {
      this.attachment.items.splice(index, 1)
    },
    getRelatedUsers() {
      this.$http.get('agendas/related-users')
          .then(({ data }) => {
            if (data.status) {
              this.receiversList = data.users
              this.getReceivers = true
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    createTicket(type) {
      this.$refs.refFormObserver.validate()
          .then(success => {
            if (success) {
              if (type === 'publish') {
                this.$swal({
                  title: 'نهایی کردن صورتجلسه',
                  text: 'در صورت نهایی شدن صورت جلسه امکان تغییر آن وجود ندارد',
                  icon: 'question',
                  showCancelButton: true,
                  cancelButtonText: 'لغو نهایی کردن',
                  confirmButtonText: 'نهایی کردن صورتجلسه',
                  customClass: {
                    confirmButton: 'btn btn-success mx-1',
                    cancelButton: 'btn btn-secondary',
                  }
                })
                    .then(result => {
                      if (result.value) {
                        this.submitAgenda(type)
                      }
                    })

              }
              else {
                this.submitAgenda(type)
              }

            }
          })
    },
    submitAgenda(type) {
      this.onProgress = true
      this.onSaving = true

      const agendaFormData = new FormData()

      agendaFormData.append('title', this.title)
      agendaFormData.append('type', type)
      agendaFormData.append('meeting_date', this.meetingDate == null ? '' : this.meetingDate)
      agendaFormData.append('description', this.description == null ? '' : this.description)
      this.members.map(member => {
        agendaFormData.append('members[]', member)
      })
      this.attachment.items.map(attachment => {
        agendaFormData.append('attachments[]', attachment.file)
      })
      this.approvals.map((item, index) => {
        agendaFormData.append(`approvals[${index}][id]`, '')
        agendaFormData.append(`approvals[${index}][title]`, item.title)
        agendaFormData.append(`approvals[${index}][due_date]`, item.dueDate == null ? '' : item.dueDate)
        agendaFormData.append(`approvals[${index}][user_id]`, item.userId)
      })

      this.$http.post('agendas', agendaFormData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
          .then(({ data }) => {
            if (data.status) {
              this.title = ''
              this.description = ''
              this.meetingDate = ''
              this.members = []
              this.approvals = []
              this.nextApprovalId = 1
              this.attachment = {
                items: [],
                nextItemId: 1,
              }

              this.$bvToast.toast('صورت جلسه  با موفقیت ثبت شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'ثبت صورت جلسه  انجام نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false

          })
    },
  },
  mounted() {
    this.getRelatedUsers()
  }
}
</script>


